import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import moment from '../../../../constants/moment';
import {
    toggleModal,
    getAll,
    setValue,
    createNew,
    update,
    deleteEntity,
    tableActions,
    
} from "../../../../../redux/actions/colorActions";
import {
    Button,
    Modal
} from "react-bootstrap";
import {
    TextField,
    FormHelperText,
    Chip,
    Avatar,
    Table,
    TableBody,
    TableHead,
    TableCell,
    TableRow
} from "@material-ui/core";
import FileUpload from "../../../../helpers/fileupload/FileUpload";
import DataTable from "../../../../helpers/datatable/DataTable";

import Loading from "../../../../helpers/loading/Loading";
import {
    sortCaret,
    headerSortingClasses,
} from "../../../../../_metronic/_helpers";
import actionsFormatter from "../../../../helpers/datatable/formatters/actionsFormatter";
import { textFilter } from 'react-bootstrap-table2-filter';

function ColorsPage(props) {
    useEffect(() => {
        props.getAll(props.auth.user.token);
        return () => {
            // will unMount 
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    
    const columns = [
        {
            dataField: "colorName",
            text: "Renk Tanımı",
            sort: true,
            filter: textFilter({
                placeholder: "Ara",
                style: {
                    display: props.color.data.length > 0 ? "block" : "none"
                }
            }),
            sortCaret: sortCaret,
            headerSortingClasses
        },
        {
            dataField: "colorCode",
            text: "Renk Kodu",
            sort: true,
            sortCaret: sortCaret,
            filter: textFilter({
                placeholder: "Ara",
                style: {
                    display: props.color.data.length > 0 ? "block" : "none"
                }
            }),
            headerSortingClasses
        },
        {
            dataField: "action",
            text: "",
            
            classes: "text-right pr-0",
            headerClasses: "text-right pr-3",
            style: {
                minWidth: "100px",
            },
            formatter: (cell, row) => {
                return actionsFormatter(cell, row, props.tableActions, props.auth.user.token)
            }

        }
    ];

    return <>
        <Loading show={props.color.isFetchingDetail} />
        <Modal backdrop="static" size="lg" show={props.color.showModal} onHide={() => props.toggleModal(false, "")}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <i style={{ marginRight: 5 }} className={props.color.process === "create" ? "fa fa-plus" : props.color.process === "update" ? "fa fa-edit" : "fa fa-trash-alt"}></i>
                    {props.color.process === "create" ? "Yeni Renk" : props.color.process === "update" ? "Renk Düzenle" : "Renk Sil"}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.color.process === "create" || props.color.process === "update" ?
                    <div>
                        <TextField
                            label="Renk Adı"

                            style={{ margin: 8 }}
                            placeholder="Renk Adı"
                            autoComplete="off"
                            error={props.color.name_error}
                            value={props.color.name}
                            onChange={(event) => props.setValue("name", event.target.value)}
                            helperText={props.color.name_helpertext}
                            fullWidth
                            margin="normal"
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            FormHelperTextProps={{
                                style: {
                                    marginLeft: 0
                                }
                            }}
                        />
                        <TextField
                            label="Renk Kodu"

                            style={{ margin: 8 }}
                            placeholder="Renk Kodu"
                            autoComplete="off"
                            error={props.color.code_error}
                            value={props.color.code}
                            onChange={(event) => props.setValue("code", event.target.value)}
                            helperText={props.color.code_helpertext}
                            fullWidth
                            margin="normal"
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            FormHelperTextProps={{
                                style: {
                                    marginLeft: 0
                                }
                            }}
                        />
                      <div style={{ marginTop:8, marginLeft : 7, width : "100%"}}>
                       <FileUpload
                            {...props}
                            multiple={false}
                            dropzoneText={"Renk İçin Resim Seçiniz"}
                            stateKey={"images"}
                            uploadedImages={props.color.images}
                        />
                      </div>
                        {
                            props.color.process === "update" && props.color.detail !== null ?
                                <>
                                    <div className="separator separator-dashed my-7"></div>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>RENK DETAYLARI</TableCell>
                                                <TableCell></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                props.color.detail.createdBy !== null ?
                                                    <TableRow>
                                                        <TableCell component="th" scope="row">
                                                            <FormHelperText>Oluşturan Kullanıcı / Zamanı</FormHelperText><br />
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            <Chip
                                                                style={{ marginLeft: -5 }}
                                                                avatar={<Avatar>{String(props.color.detail.createdBy.name[0]).toUpperCase() + String(props.color.detail.createdBy.surname[0]).toUpperCase()}</Avatar>}
                                                                label={props.color.detail.createdBy.username}
                                                            /><br />
                                                            <small>{moment(props.color.detail.createdAt).format('DD.MM.YYYY HH:mm:ss')}</small><br />
                                                            <small>{moment(props.color.detail.createdAt).fromNow()}</small>
                                                        </TableCell>
                                                    </TableRow> : null
                                            }

                                            {
                                                props.color.detail.updatedBy !== undefined && props.color.detail.updatedBy !== null ?
                                                    <TableRow>
                                                        <TableCell component="th" scope="row">
                                                            <FormHelperText>Son Güncelleyen Kullanıcı / Zamanı</FormHelperText>
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            <Chip
                                                                style={{ marginLeft: -5 }}
                                                                avatar={<Avatar>{String(props.color.detail.updatedBy.name[0]).toUpperCase() + String(props.color.detail.updatedBy.surname[0]).toUpperCase()}</Avatar>}
                                                                label={props.color.detail.updatedBy.username}
                                                            /><br />
                                                            <small>{moment(props.color.detail.updatedAt).format('DD.MM.YYYY HH:mm:ss')}</small><br />
                                                            <small>{moment(props.color.detail.updatedAt).fromNow()}</small>
                                                        </TableCell>
                                                    </TableRow> : null
                                            }
                                        </TableBody>
                                    </Table></> : null
                        }
                    </div> :
                    props.table.row !== null && props.table.row.colorName ?
                        <>
                            <b>{'"'}{props.table.row.colorName}{'" '}</b> isimli kampanyayı silmek üzeresiniz. İşlemi onaylıyor musunuz?
                  </> : null
                }
            </Modal.Body>
            <Modal.Footer>
                <Button disabled={props.color.isFetchingActions} variant="secondary" onClick={() => props.toggleModal(false, props.color.process)}>
                    İptal
            </Button>
                <Button style={{ minWidth: 50, minHeight: 39, display: "flex", flexDirection: "row", alignItems: "center" }} disabled={props.color.isFetchingActions} onClick={() => {
                    if (props.color.process === "create") {
                        props.createNew(props.auth.user.token,
                            [
                                {
                                    key: "name",
                                    value: props.color.name,
                                    required: true
                                },
                                {
                                    key: "code",
                                    value: props.color.code,
                                    required: true
                                },
                                {
                                    key: "images",
                                    value: props.color.images,
                                    required: false
                                }
                            ])
                    } else if (props.color.process === "update") {
                        props.update(props.auth.user.token, props.table.row.id,
                            [
                                {
                                    key: "name",
                                    value: props.color.name,
                                    required: true
                                },
                                {
                                    key: "code",
                                    value: props.color.code,
                                    required: true
                                },
                                {
                                    key: "images",
                                    value: props.color.images,
                                    required: false
                                }

                            ], props.table.index);
                    } else {
                        props.deleteEntity(props.auth.user.token, props.table.row, props.table.index);
                    }
                }} variant="primary">
                    {
                        props.color.isFetchingActions ?
                            <span className="ml-3 spinner spinner-white"></span> :
                            props.color.process === "delete" ? "Sil" : "Kaydet"
                    }
                </Button>
            </Modal.Footer>
        </Modal>
        <DataTable
            handleModal={props.toggleModal}
            title="Tüm Renkler"
            buttonTitle="Yeni Renk"
            cardIcon="fa fa-fill-drip"
            buttonIcon="fa fa-plus"
            searchPlaceholder="Ara"
            data={props.color.data}
            columns={columns}
        />
    </>
}

const mapStateToProps = function (state) {
    return {
        auth: state.auth,
        color: state.color,
        table: state.table
    }
}

export default connect(mapStateToProps,
    {
        toggleModal,
        getAll,
        setValue,
        createNew,
        update,
        deleteEntity,
        tableActions,
        
    })(ColorsPage);
